import { supabaseClient } from 'supabase'
import { ApplicationRow } from './deskTypes'

export const DESK_SIBLING_COLUMNS = 'id, event_index, event_title, processed, desk_decision'

export type DeskSibling = Pick<
  ApplicationRow,
  'id' | 'event_index' | 'event_title' | 'processed' | 'desk_decision'
>

/**
 * Every editor candidate made from one raw item, in the editor's order (D-05:
 * the sibling strip). Includes the current candidate; the caller marks it.
 * Only editor rows: `.not('editor_version', 'is', null)`, never an `.eq` with
 * null (PostgREST `.eq` never matches null).
 */
export const queryDeskSiblings = async (rawItemId: number): Promise<DeskSibling[]> => {
  const { data, error } = await supabaseClient
    .from('applications')
    .select(DESK_SIBLING_COLUMNS)
    .eq('raw_item_id', rawItemId)
    .not('editor_version', 'is', null)
    .order('event_index')

  if (error) {
    throw error
  }
  return data ?? []
}
